import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Container, Box } from "@mui/material";
import ChatHome from "./ChatHome";
import ChatRoom from "./ChatRoom";

const ChatPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 3 }}>
        <Routes>
          <Route index element={<ChatHome />} />
          <Route path=":chatId" element={<ChatRoom />} />
          <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
      </Box>
    </Container>
  );
};

export default ChatPage;
